export enum ProtectionConfirmationPanelTestHooks {
  Panel = 'order-confirmation-protection-panel',
  Plan = 'plan-description-list-item',
}
